export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/student/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/student/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sku/student/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sku/student/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/student/delete`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/student.js